import { CheckCircle2, Activity, Circle } from "lucide-react";

interface TestStatusBadgeProps {
  status: string;
}

export function TestStatusBadge({ status }: TestStatusBadgeProps) {
  const isCompleted = status === "completed";
  const isRunning = status === "running";

  const label =
    status === "draft" || status === "paused"
      ? "Planning"
      : status === "building"
        ? "Drafting"
        : isCompleted
          ? "Complete"
          : isRunning
            ? "Running"
            : status;

  const colorClass = isCompleted
    ? "text-status-success-strong"
    : isRunning
      ? "text-status-info-strong"
      : "text-muted-foreground";

  return (
    <span className="inline-flex items-center gap-1.5 shrink-0">
      {isCompleted ? (
        <CheckCircle2 className="h-4 w-4 text-status-success-strong" strokeWidth={2} />
      ) : isRunning ? (
        <Activity className="h-4 w-4 text-status-info-strong" strokeWidth={2} />
      ) : (
        <Circle className="h-4 w-4 text-muted-foreground" strokeWidth={2} />
      )}
      <span className={`text-xs font-medium ${colorClass}`}>{label}</span>
    </span>
  );
}
